import { Icon } from '@winnin/winnin_ui.components.icon'

import { CloudApproveIcon, CloudErrorIcon, CloudLoadingIcon } from 'assets/icons'
import { RCTooltip } from 'components/RCTooltip'

import type { TVideoIconStatusViewProps } from './video-icon-status.types'
import { ENTITY_UPDATE_STATUS } from '../common/posts.consts'

import './video-icon-status.styles.scss'

const ICON_MAP = {
  [ENTITY_UPDATE_STATUS.SUCCESS]: <CloudApproveIcon aria-hidden="true" />,
  [ENTITY_UPDATE_STATUS.RUNNING]: <CloudLoadingIcon aria-hidden="true" />,
  [ENTITY_UPDATE_STATUS.FAILED]: <CloudErrorIcon aria-hidden="true" />,
}

export const VideoIconStatusView = ({
  iconType,
  tooltipIconPost,
  showTooltip,
  postUrl,
  isClickable,
  isSuccessClickable,
  iconWrapperClasses,
}: TVideoIconStatusViewProps) => {
  const icon = iconType ? ICON_MAP[iconType] : null

  if (!icon) {
    return null
  }

  return (
    <div className="VideoIconStatus" data-testid="video-icon-status">
      <RCTooltip tooltipMessage={tooltipIconPost} direction="bottom" hideTooltip={!showTooltip}>
        {isClickable ? (
          <a
            className={iconWrapperClasses}
            href={postUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={tooltipIconPost}
            data-testid="video-icon-status-link"
            data-dd-action-name="open-video-post"
          >
            <span className="VideoIconStatus__icon-default">{icon}</span>
            {isSuccessClickable && (
              <span className="VideoIconStatus__icon-hover">
                <Icon icon="videoOutline" fill="currentColor" width={16} height={16} aria-hidden="true" />
              </span>
            )}
          </a>
        ) : (
          <div className={iconWrapperClasses} data-testid="video-icon-status-icon">
            {icon}
          </div>
        )}
      </RCTooltip>
    </div>
  )
}
